export default __webpack_public_path__ + "static/politica-de-calidad-e5b987849a5f3b0c28d0604f8ad1f5ee.pdf";